import React, { useEffect, useState } from 'react';
import "./PopularLocations.css";
import Card from "./PopularLocation-Card";
import axios from 'axios';
import { Puff } from "react-loader-spinner";

const data = [
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
  {
    imgUrl: "/img1.png",
    count: "20+ properties",
    category: "Famous Beach",
    url: "/",
  },
];

const Holder = () => {
  const [villas, setVillas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get user's IP address
        const ipResponse = await axios.get('https://api.ipify.org?format=json');
        const ipAddress = ipResponse.data.ip;

        // Get user's latitude and longitude
        const geoResponse = await axios.get(`http://ip-api.com/json/${ipAddress}`);
        const { lat, lon } = geoResponse.data;

        // Get villa data from your Django API
        const villaResponse = await axios.get(
          `http://localhost:8000/api/v1/nearest_addresses/?latitude=${lat}&longitude=${lon}`
        );
        setVillas(villaResponse.data.villas);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="font-hk bg-[#f0ede8] w-[96.5vw] md:w-[88.5vw] mx-auto h-auto rounded-3xl shadow-slate-400 shadow-md py-4 ">
      <ul className="cards">
        {villas.length>0?(<>{villas.map((data, i) => {
          return (
            <li className="m-5">
              <Card data={data}/>
            </li>
          );
        })}</>):(<>
       <div className="grid grid-cols-2 md:grid-cols-3 gap-5 p-20 cards">
       <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <Puff
          height="110"
          width="110"
          radius={1}
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
       </div>
       
       
        </>)}
      </ul>
    </div>
  );
};

export default Holder;
